const sum = (x: Array<number>) => x.reduce((sum, x) => sum + x, 0);

class StatisticsService {
  static views(models: Array<Model>, posts: Array<ReportPost>) {
    const model_posted = posts.map((post) => post.model && post.model.id);
    const total = models
      .filter((item) => model_posted.includes(item.id))
      .map((item) => (item.instagram ? item.instagram.number_of_followers : 0));
    return sum(total);
  }

  static likes(posts: Array<ReportPost>) {
    return sum(posts.map((item) => item.count_of_likes || 0));
  }

  static comments(posts: Array<ReportPost>) {
    return sum(posts.map((item) => item.count_of_comments || 0));
  }

  static filterUniquePosts(posts: Array<ReportPost>): Array<ReportPost> {
    const firsts: Array<ReportPost> = [];
    posts.reduce((p: Array<string>, c: ReportPost) => {
      const id = c.instagram_id;
      if (!p.includes(id)) {
        p.push(id);
        firsts.push(c);
      }
      return p;
    }, []);
    return firsts;
  }

  static filterUniqueById<T>(arr2: Array<T>, key: string) {
    const prop = 'id';
    const arr = [].concat.apply(
      [],
      arr2.map((item: T) => item[key])
    );
    return arr.filter((obj, pos, arr) => {
      return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
  }
}

export default StatisticsService;
